import { PointProperties } from '@/api/modules/delivery/types'

export interface AutocompleteSuggestion {
  value: string | null
}

export interface AutocompleteService {
  getSuggestions: (query: string) => Promise<Partial<SuggestedOfAddress>[]>
}

// Состояния поиска адреса
export enum StateGeoAddress {
  LOADING,
  READY,
}

// Состояние карты
export type StateOfMap = 'pending' | 'loading' | 'loaded' | 'error'

export interface StatesContainer {
  [key: string]: StateOfMap
}

// Типы объектов карт
export enum TypesEntity {
  HOTSPOT = 'hotspot',
  FEATURE = 'feature',
  MARKER = 'marker',
}

// Типы провайдера
export enum TypesProvider {
  YANDEX = 'Yandex',
  GOOGLE = 'Google',
}

export interface IGoogleCoords {
  lat: number
  lng: number
}

export type EmitDataOfMap = {
  type: TypesEntity
  coords: IGoogleCoords
  point?: PointProperties
}

export interface GoogleClickEvent {
  domEvent: MouseEvent
  ei: string
  latLng: google.maps.LatLng
  pixel: string
}
